module.exports = __webpack_public_path__ + "static/Diversity_logo-9bbe21c9d5cf714a955da060859f74ff.png";